import { render, staticRenderFns } from "./posterSetting.vue?vue&type=template&id=78bccd72&"
import script from "./posterSetting.vue?vue&type=script&lang=js&"
export * from "./posterSetting.vue?vue&type=script&lang=js&"
import style0 from "./posterSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports